import React from 'react'
import {
  useConfirmModal,
  ConfirmModal
} from '@@partner:helpers/hooks/useConfirmModal'

import { Button } from 'rsuite'
import IconTrash from '@rsuite/icons/Trash'

export interface DropzonePreview {
  url?: string
  onDelete: () => void
  noConfirm?: boolean
  imageClassName?: string
}

export default function DropzonePreview ({
  url,
  onDelete,
  noConfirm = false,
  imageClassName = 'w-64'
}: DropzonePreview) {
  const { confirm: confirmDelete, confirmModalProps } = useConfirmModal({
    onConfirm: ({ close }) => {
      onDelete()
      close()
    },
    title: 'Уверены?',
    content: 'Вы собираетесь удалить привязанное изображение'
  })

  if (!url) {
    return null
  }

  return (
    <div className="w-full flex items-center justify-center flex-col">
      <img className={`${imageClassName} block`} src={url} />
      <Button
        className="mt-2"
        size="xs"
        appearance="primary"
        color="red"
        onClick={() => (noConfirm ? onDelete() : confirmDelete())}
      >
        <IconTrash /> Удалить
      </Button>

      {noConfirm === false && <ConfirmModal {...confirmModalProps} />}
    </div>
  )
}
